var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"right"}},[_c('span',[_vm._v("\n    "+_vm._s(Number(Number(_vm.getValue()).toFixed(_vm.decimalLength||_vm.decimalPlace[_vm.field]||_vm.decimalPlace.all)).toLocaleString('ja-JP', { minimumFractionDigits:(_vm.decimalLength||_vm.decimalPlace[_vm.field]||_vm.decimalPlace.all) }))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }